import { useMemo } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import SetPasswordForm from '../_shared/SetPasswordForm';

export default function CandidateResetPassword() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  if (!token || token.length < 32) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
        <div className="surface-elevated p-8 max-w-md w-full text-center">
          <h1 className="text-lg font-semibold text-slate-900">Invalid or missing link</h1>
          <p className="text-sm text-slate-500 mt-2">Open the full link from your reset email, or request a new reset.</p>
          <Link to="/candidate/forgot-password" className="inline-block mt-6 text-brand-600 hover:underline text-sm">Request new link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="surface-elevated p-8">
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Set a new password</h2>
          <p className="text-sm text-slate-500 mb-6">Choose a strong password for your candidate account.</p>
          <SetPasswordForm
            token={token}
            endpoint="/auth/candidate-reset-password"
            redirectTo="/candidate/login"
            recovery={
              <Link to="/candidate/forgot-password" className="font-medium text-danger-800 underline hover:text-danger-900">
                Request a new reset link
              </Link>
            }
          />
        </div>
        <p className="text-center text-slate-500 text-sm mt-6">
          <Link to="/candidate/login" className="text-brand-600 hover:underline">Back to candidate sign in</Link>
        </p>
      </div>
    </div>
  );
}
